<template>
    <div id="app-ssr" :class="{isHomepage:isHome}">
        <modal-cookies-component></modal-cookies-component>

        <suggest-region-redirect-component></suggest-region-redirect-component>
        <rebrand-top-bar-component></rebrand-top-bar-component>
        <rebrand-header-component :class="{'no-horizontal-menu-on-moble': user}"></rebrand-header-component>
        <rebrand-mobile-horizontal-menu-component v-if="!user"></rebrand-mobile-horizontal-menu-component>
        <div id="content" :class="{'pt-0': isSeoPage, 'is-gold-venue-profile': isGoldVenueProfile}">
            <div class="container">
                <modal-escort-call-feedback-component></modal-escort-call-feedback-component>
                <router-view @user-initialised="setUser"></router-view>
            </div>
        </div>
        <footerbar-component></footerbar-component>
    </div>
</template>

<script>

import userMixin from "@/components/mixins/userMixin";
import {checkIfUserHasRole} from "@/core/utils/helpers/checkIfUserHasRole";

const data = () => {
    return {
        user: null,
    }
}

export default {
    data,
    created() {
        this.user = _.get(context, 'preFetchedUser');
    },
    mounted() {
        window.history.scrollRestoration = "manual";
    },
    computed: {
        ...mapState(['preFetchedUser']),
        isHome() {
            return _.get(this, '$route.name', null) === 'home';
        },
        isSeoPage() {
            return _.get(this, '$route.name', null) === 'seo';
        },
        isGoldVenueProfile() {
            return this.user && checkIfUserHasRole(constants.user_role.VENUE, this.user) && this.isGoldUser(this.user);
        },
    },
    mixins: [userMixin],
    methods: {
        setUser(user) {
            this.user = user;
        },
    },
    watch: {
        '$route'() {
            // Without this if user uses back button on browser from profile page it still has the user data and thinks he is in profile page
            this.user = null;
        }
    }
}
</script>
